export default {
    userId: "",
    userPicture: "https://tomatofile.incmoon.com/image/img_userPicture/user_default.png",
    userIdentityNumber: 0,
    userNickName: "",
    vipInfo: {userRole: "normal"},
    loading: false,
}